import Fetch from 'jsx/common/util/_fetch';

export const deleteConfig = async (id: string) => {
  return await Fetch.delete(
    `/api/applications/assetmanagement/isae/delete_configuration/?id=${id}`
  );
};
